import React from 'react'
import { Modal } from 'antd'
import {  CloseOutlined, DownloadOutlined } from '@ant-design/icons'
import { commonUtils } from '@/helpers/commonUtils'
import styles from './DownloadProgressModal.module.less'
import { uiController } from '@/controllers/uiController'
export interface DownloadProgressModalProps {
  visible: boolean
  onClose: () => void
}

const DownloadProgressModal: React.FC<DownloadProgressModalProps> = ({
  visible,
  onClose,
}) => {
  return (
    <Modal
      open={visible}
      footer={null}
      closable={true}
      closeIcon={<CloseOutlined />}
      onCancel={onClose}
      width={480}
      centered
      title={null}
      styles={{
        body: {
          padding: 0,
        },
        content: {
          padding: '18px 18px 16px',
          overflow: 'hidden',
          borderRadius: 18,
        },
      }}
      className={styles.downloadProgressModal}
    >
      <div className={styles.content}>
        <div className={styles.headerCard}>
          <div className={styles.downloadIcon}>
            <DownloadOutlined />
          </div>
          <div className={styles.headerText}>
            <div className={styles.title}>
              课件正在下载中
            </div>
            <div className={styles.description}>
              请前往浏览器【下载列表】
              <br />
              或电脑【下载】文件夹查看进度
            </div>
            <div className={styles.tip}>下载时间根据文件大小有所不同，请耐心等待</div>
          </div>
        </div>

        <div className={styles.divider}>等待下载期间，为您推荐</div>

        <div className={styles.aiCard}>
          <div className={styles.aiPreview} onClick={() => {uiController.openBiluSso('pc_web','pc详情页下载弹窗','download')}}>
              <img src={commonUtils.getStaticFile('pc/bilu.jpg')} alt='ai-preview' />
          </div>
        </div>

        <button type='button' className={styles.confirmButton} onClick={onClose}>
          我知道了，继续查看课件
        </button>
      </div>
    </Modal>
  )
}

export default DownloadProgressModal
